import { InputNumber, Select, Space } from 'antd'
import { isNil } from 'lodash'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { StartPriceInputProps } from './interface'

const defaultOptions = [
  {
    label: '允许使用起拍价',
    value: true
  },
  {
    label: '不允许使用起拍价',
    value: false
  }
]

const Component = ({
  disabled,
  value = {},
  allowNull = false,
  startPriceOptions = defaultOptions,
  onChange
}: StartPriceInputProps) => {
  const handleSelectChange = (allowStartPrice: boolean) => {
    onChange?.({ ...value, allowStartPrice })
  }

  const handleInputChange = (startPrice: string | number | null) => {
    onChange?.({
      ...value,
      startPrice: isNil(startPrice)
        ? allowNull
          ? startPrice
          : 0
        : Number(startPrice)
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={startPriceOptions}
        value={value.allowStartPrice}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <InputNumber
        disabled={disabled}
        min={0}
        style={{ width: '100%' }}
        value={value.startPrice}
        onChange={handleInputChange}
      />
      <Space.Addon>元</Space.Addon>
    </Space.Compact>
  )
}

export const StartPriceInput = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
